export default __webpack_public_path__ + "static/media/Lion.5379fe84.jpg";